import { render, staticRenderFns } from "./facial_info_list.vue?vue&type=template&id=03d7e3e3"
import script from "./facial_info_list.vue?vue&type=script&lang=js"
export * from "./facial_info_list.vue?vue&type=script&lang=js"
import style0 from "./facial_info_list.vue?vue&type=style&index=0&id=03d7e3e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports